/* Estado de la suscripción de un proveedor a partir de lo que devuelve su panel (user_info de
   Xtream Codes). Módulo puro: no toca red, DOM ni almacenamiento. */

export const SOON_DAYS = 7;
const DAY = 86400000;

/**
 * account: { user: { status, exp_date, is_trial, active_cons, max_connections } } o null (listas
 * M3U, que no tienen cuenta). `simulate`: 'expired' | 'expiring' para probar sin tocar al proveedor.
 *
 * Devuelve { state, expiresAt, daysLeft, trial, active, max, simulated } con state:
 *   'none'      no hay datos de cuenta
 *   'active'    en vigor (expiresAt = 0 si no caduca nunca)
 *   'expiring'  en vigor, caduca en SOON_DAYS días o menos
 *   'expired'   caducada
 *   'disabled'  deshabilitada o bloqueada por el proveedor
 * daysLeft son días completos hasta la caducidad (negativo si ya pasó, null si no caduca).
 */
export function subscriptionOf(account, { now = Date.now(), simulate = '' } = {}) {
    const user = account && account.user ? account.user : null;
    const out = { state: 'none', expiresAt: 0, daysLeft: null, trial: false, active: 0, max: 0, simulated: false };
    if (simulate === 'expired' || simulate === 'expiring') {
        const expiresAt = simulate === 'expired' ? now - 5 * DAY : now + 3 * DAY;
        return Object.assign(out, {
            state: simulate, expiresAt, daysLeft: simulate === 'expired' ? -5 : 3, simulated: true,
            active: user ? Number(user.active_cons) || 0 : 0, max: user ? Number(user.max_connections) || 0 : 0
        });
    }
    if (!user) return out;
    const status = String(user.status || '').toLowerCase();
    const exp = Number(user.exp_date) || 0;
    out.expiresAt = exp ? exp * 1000 : 0;
    // Días completos: «quedan 2 días» con 2,9 y «hace 5 días» con 5,2 (nunca un día de más).
    out.daysLeft = exp ? Math.trunc((out.expiresAt - now) / DAY) || 0 : null;
    out.trial = String(user.is_trial) === '1';
    out.active = Number(user.active_cons) || 0;
    out.max = Number(user.max_connections) || 0;
    if (status === 'disabled' || status === 'banned' || String(user.auth) === '0') out.state = 'disabled';
    else if (status === 'expired' || (exp && out.expiresAt <= now)) out.state = 'expired';
    else if (exp && out.expiresAt - now <= SOON_DAYS * DAY) out.state = 'expiring';
    else out.state = 'active';
    return out;
}

/** ¿Impide reproducir? */
export function blocksPlayback(sub) {
    return !!sub && (sub.state === 'expired' || sub.state === 'disabled');
}
